(function () {
  const btnScrollUp = document.querySelector(".goUp");

  btnScrollUp.addEventListener("click", (e) => {
    e.preventDefault();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  });

  window.onscroll = scrollFunction;

  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      btnScrollUp.style.display = "block";
    } else {
      btnScrollUp.style.display = "none";
    }
  }
})();
